






























































































































































import { Component } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import PaymentForm from '@/components/venue/form/PaymentForm.vue';
import GeneralForm from '@/components/venue/form/GeneralForm.vue';
import SlotForm from '@/components/venue/form/SlotForm.vue';
import OrderForm from '@/components/venue/form/OrderForm.vue';
import PreorderForm from '@/components/venue/form/PreorderForm.vue';
import TerminalForm from '@/components/venue/form/TerminalForm.vue';
import CheckoutIntegrationForm from '@/components/venue/form/CheckoutIntegrationForm.vue';
import StackedForm from '@/mixins/StackedForm';
import { EditVenue as EditVenueMixin } from '@/mixins/EditVenue';
import { mixins } from 'vue-class-component';
import { namespace } from 'vuex-class';
import OpeningHourForm from '@/components/venue/form/OpeningHourForm.vue';
import DeliveryHourForm from '@/components/venue/form/DeliveryHourForm.vue';
import DeliverProvidersForm from '@/components/venue/form/DeliverProvidersForm.vue';
import EditVenueLoader from '@/components/venue/EditVenueLoader.vue';
import DocumentForm from '@/components/venue/form/DocumentForm.vue';
import InvoiceForm from '@/components/venue/form/InvoiceForm.vue';
import { Permission } from '@/enums/Permission';
import { CustomerGroup } from '@/enums/CustomerGroup';
import OrderServiceApi from '@/api/http/OrderServiceApi';
import OrderOffsetForm from '@/components/venue/form/OrderOffsetForm.vue';
import PaymentApiService from '@/api/http/PaymentApiService';
import { VenueInvoiceType } from '@/enums/VenueInvoiceType';
import { VenueTransaction, VenueTransactions } from '@/interfaces/models/VenueTransactions';
import { AxiosError, AxiosResponse } from 'axios';
import { VenueSepa } from '@/interfaces/models/VenueSepa';
import { toUrl } from '@/util/helper';

const venue = namespace('venue');
const venueInvoice = namespace('venueTransactions');

@Component({
  components: {
    OrderOffsetForm,
    EditVenueLoader,
    DeliveryHourForm,
    DeliverProvidersForm,
    OpeningHourForm,
    CheckoutIntegrationForm,
    TerminalForm,
    PreorderForm,
    OrderForm,
    SlotForm,
    DocumentForm,
    InvoiceForm,
    GeneralForm,
    PaymentForm,
    VWrapper,
  },
})
export default class EditVenue extends mixins(StackedForm, EditVenueMixin) {
  @venueInvoice.State('items') public venueTransactions!: VenueTransactions;
  @venueInvoice.Action('fetch') public getVenueTransactions!: any;

  public $refs!: {
    general: InstanceType<typeof GeneralForm> & { getData: () => any };
    payment: InstanceType<typeof PaymentForm> & { getData: () => any };
    order: InstanceType<typeof OrderForm> & { getData: () => any };
    preorder: InstanceType<typeof PreorderForm> & { getData: () => any };
    terminal: InstanceType<typeof TerminalForm> & { getData: () => any };
    ci: InstanceType<typeof CheckoutIntegrationForm> & { getData: () => any };
    slot: InstanceType<typeof SlotForm> & { getData: () => any };
    documents: InstanceType<typeof DocumentForm> & { getData: () => any };
    openingHours: InstanceType<typeof OpeningHourForm> & { getData: () => any };
    deliveryHours: InstanceType<typeof DeliveryHourForm> & { getData: () => any };
    deliveryProviders: InstanceType<typeof DeliverProvidersForm> & { getData: () => any };
    offsets: InstanceType<typeof OrderOffsetForm> & { getData: () => any };
  };

  get canMakeTestOrder() {
    return (
      this.$can(Permission.ORDER_TEST) &&
      this.editing &&
      this.venue &&
      this.venue.customerGroup === CustomerGroup.Subway &&
      this.venue.isPublished === true
    );
  }

  get shouldDisableRegister() {
    return this.venue && this.venue.customerGroup === CustomerGroup.SubwayFr;
  }

  get sepaMandate(): string {
    return (
      (this.venue &&
        this.venue.invoiceReceiver &&
        this.venue.invoiceReceiver.sepa &&
        this.venue.invoiceReceiver.sepa.sepaMandateRef) ||
      ''
    );
  }

  get sepaMandateUrl(): string {
    return this.sepaMandate ? `${process.env.VUE_APP_GOCARDLESS_URL}/mandates/${this.sepaMandate}` : '';
  }

  public loadVenueTransactions() {
    this.getVenueTransactions({ venue: this.$route.params.id });
  }

  public sendInvoice(selectedInvoiceType: VenueInvoiceType) {
    this.$startLoading('venue.sendInvoice');
    const api: PaymentApiService = new PaymentApiService();
    api
      .sendBillomatInvoice({ venue: this.venue!._id, invoiceType: selectedInvoiceType })
      .then(async () => {
        await this.loadVenueTransactions();
        this.notifySuccess('venue.notification.sendInvoiceSuccess');
      })
      .catch((err: AxiosError) => {
        let msg: string = `${this.$t('venue.notification.sendInvoiceError')}`;
        if (err.response && err.response.data) {
          msg += `: ${err.response.data.message}`;
        }
        this.notifyError(msg);
      })
      .finally(() => {
        this.$stopLoading('venue.sendInvoice');
      });
  }

  public sepaPay(transaction: VenueTransaction, description: string) {
    const params: {
      id: string;
      description: string;
      invoiceNumber: string;
    } = { id: this.venue!._id, description, invoiceNumber: transaction.invoiceRef! };

    const api: PaymentApiService = new PaymentApiService();
    api
      .sepaPay(params)
      .then(async () => {
        await this.loadVenueTransactions();
        this.notifySuccess('venue.notification.sepa.paySuccess');
      })
      .catch((err: AxiosError) => {
        let msg: string = `${this.$t('venue.notification.sepa.payError')}`;
        if (err.response && err.response.data) {
          msg += `: ${err.response.data.message}`;
        }
        this.notifyError(msg);
      });
  }

  public downloadOrdersPdf(transaction: VenueTransaction) {
    const api: PaymentApiService = new PaymentApiService();
    api
      .downloadOrdersPdf({ venue: this.venue!._id, transactionId: transaction._id })
      .then((response: AxiosResponse) => {
        toUrl(response.data, `${transaction.provisionMonth}-Orders.pdf`);
      })
      .catch((err: AxiosError) => {
        this.notifyError('notification.downloadFailed');
      });
  }

  public testOrder() {
    const api: OrderServiceApi = new OrderServiceApi();
    api
      .testOrder({ venue: this.venue!._id })
      .then(() => {
        this.notifySuccess('venue.notification.testOrderSuccess');
      })
      .catch(() => {
        this.notifyError('venue.notification.testOrderError');
      });
  }

  public async save() {
    Promise.all(await this.validate()).then(async (res: any) => {
      if (this.isValid(res)) {
        this.$startLoading('venue.save');
        const mergedData: any = this.getMergedData();
        const documents: { terms: string | Blob; imprint: string | Blob; privacy: string | Blob } = {
          ...mergedData.legal,
        };
        const data: any = this.sanitize(mergedData);

        if (this.editing) {
          data.id = this.active._id;
          await this.update(data);
        } else {
          await this.store(data);
        }

        if (!this.active) {
          this.$router.push({ name: 'venue.index' });
          this.$stopLoading('venue.save');
          return;
        }
        const formData: FormData = new FormData();
        if (data.nutritionTableFile && data.nutritionTableFile.length > 0) {
          formData.append('file', data.nutritionTableFile.pop());
          await this.uploadNutritionTable({ id: this.active._id, file: formData });
        }
        if (documents.terms && documents.terms instanceof File) {
          formData.set('file', documents.terms);
          await this.uploadTermsAndConditions({ id: this.active._id, file: formData });
        }
        if (documents.imprint && documents.imprint instanceof File) {
          formData.set('file', documents.imprint);
          await this.uploadImprint({ id: this.active._id, file: formData });
        }
        if (documents.privacy && documents.privacy instanceof File) {
          formData.set('file', documents.privacy);
          await this.uploadPrivacy({ id: this.active._id, file: formData });
        }
        if (data.image && data.image.length > 0) {
          formData.append('asset', data.image.pop());
          await this.uploadImage({ id: this.active._id, file: formData });
        }
        this.$router.push({ name: 'venue.index' });
        this.$stopLoading('venue.save');
      } else {
        this.notifyError('notification.form');
      }
    });
  }

  public getMergedData() {
    return {
      ...this.$refs.general.getData(),
      ...this.$refs.payment.getData(),
      ...this.$refs.order.getData(),
      ...this.$refs.preorder.getData(),
      ...this.$refs.terminal.getData(),
      ...this.$refs.ci.getData(),
      ...this.$refs.deliveryHours.getData(),
      ...this.$refs.deliveryProviders.getData(),
      ...this.$refs.openingHours.getData(),
      ...this.$refs.slot.getData(),
      ...this.$refs.documents.getData(),
      ...this.$refs.offsets.getData(),
    };
  }
}
